import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=a668a536&"
import script from "./Announcements.vue?vue&type=script&lang=js&"
export * from "./Announcements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a668a536')) {
      api.createRecord('a668a536', component.options)
    } else {
      api.reload('a668a536', component.options)
    }
    module.hot.accept("./Announcements.vue?vue&type=template&id=a668a536&", function () {
      api.rerender('a668a536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Announcements.vue"
export default component.exports